import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ValidatorService } from '../validation.service';

@Component({
  selector: 'app-radio-field',
  templateUrl: './radio-field.component.html',
  styleUrls: ['./radio-field.component.css']
})
export class RadioFieldComponent {

  @Input()
  values: string[];

  @Input()
  form: FormGroup;

  @Output()
  formChange = new EventEmitter<FormGroup>();

  @Input()
  controlName: string;

  // below optional

  @Input()
  images: string[];

  @Input()
  label: string;

  @Input()
  subLabels: string[] = [];

  @Input()
  invalidMessage: string;

  @Input()
  disabled: boolean | any;

  constructor(public validator: ValidatorService) { }
}
